module.exports = __webpack_public_path__ + "img/CORE.66c94003.png";